const AlocacaoCargaTipoColetaEnum = {
    CROSSDOCKING: 1,
    ENTREGA_CLIENTE: 2
}

export default AlocacaoCargaTipoColetaEnum;